export default "__VITE_ASSET__BBunoNh5__"